import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useVorschauPdfMutation } from '../../api/FakturaAPI';

export default function RechnungslaufVorschau() {

    var url = window.location;
    let params = new URLSearchParams(url.search);
    const uid = params.get('id');


    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [vorschauAPI] = useVorschauPdfMutation();
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [filename, setFilename] = useState<string | null>(null);


    const lade = async () => {

        const { blob, filename } = await vorschauAPI(uid).unwrap();

        const url = window.URL.createObjectURL(blob);
        setPdfUrl(url);
        setFilename(filename);
        /*const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);*/
    }

    const download = async () => {
        if (pdfUrl && filename) {
            const a = document.createElement('a');
            a.href = pdfUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(pdfUrl);
        }
    }

    useEffect(() => {
        lade();
    }, []);

    return (
        <>

            <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>

                    <button
                        onClick={() => {
                            navigate({
                                pathname: "/faktura/rechnungslaufliste",
                                search: ""
                            });
                        }}

                        style={{ marginBottom: "20px" }}
                        className=' btn btn-outline-primary'
                    >
                        <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                    </button>
                </div>

                <h3>Vorschau</h3>


                <button
                    onClick={() => download()}
                    style={{ marginBottom: "20px" }}
                    className=' btn btn-outline-primary'
                >
                    <i className="bi bi-download"></i> Download
                </button>

                <div style={{ flex: 1, minHeight: 0 }}>
                    {pdfUrl !== null &&
                        <iframe
                            src={pdfUrl}
                            title="PDF Vorschau"
                            style={{ width: "100%", height: "100%", border: "none" }}
                        />}
                </div>

            </div >

        </>
    );
}
